import axiosInstance from "./api";

export interface PhoneVerificationStatus {
  mobilePhone: string | null;
  primaryPhone: string | null;
  mobilePhoneVerified: boolean;
  mobilePhoneVerifiedAt: string | null;
}

export interface VerifyPhoneCodeResponse {
  message: string;
  mobilePhone: string;
  mobilePhoneVerified: boolean;
  mobilePhoneVerifiedAt: string;
}

const PHONE_VERIFICATION_API = {
  status: "/v1/phone-verification/status",
  sendCode: "/v1/phone-verification/send-code",
  verifyCode: "/v1/phone-verification/verify-code",
} as const;

function authHeaders(token: string) {
  return {
    Authorization: `Bearer ${token}`,
  };
}

class PhoneVerificationService {
  getStatus(token: string): Promise<PhoneVerificationStatus> {
    return axiosInstance
      .get(PHONE_VERIFICATION_API.status, {
        headers: authHeaders(token),
      })
      .then((res) => res.data.data);
  }

  sendCode(
    token: string,
    mobilePhone?: string
  ): Promise<{ message: string }> {
    const body = mobilePhone ? { mobilePhone } : {};
    return axiosInstance
      .post(PHONE_VERIFICATION_API.sendCode, body, {
        headers: authHeaders(token),
      })
      .then((res) => res.data);
  }

  verifyCode(token: string, code: string): Promise<VerifyPhoneCodeResponse> {
    return axiosInstance
      .post(
        PHONE_VERIFICATION_API.verifyCode,
        { code },
        {
          headers: authHeaders(token),
        }
      )
      .then((res) => res.data);
  }
}

export default new PhoneVerificationService();
